/**
 * @generated SignedSource<<69305d2d25892867fa6fc02cd144817a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AssigneesSectionCopilotRepositoryFragment$data = {
  readonly databaseId: number | null | undefined;
  readonly isArchived: boolean;
  readonly isPrivate: boolean;
  readonly nameWithOwner: string;
  readonly " $fragmentType": "AssigneesSectionCopilotRepositoryFragment";
};
export type AssigneesSectionCopilotRepositoryFragment$key = {
  readonly " $data"?: AssigneesSectionCopilotRepositoryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AssigneesSectionCopilotRepositoryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AssigneesSectionCopilotRepositoryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameWithOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArchived",
      "storageKey": null
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "334278d4818675b89da4d52e5d035343";

export default node;
